// // src/components/MCPMDetail.tsx
// import React, { useEffect, useMemo, useState } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import {
//   Box,
//   Typography,
//   Button,
//   Accordion,
//   AccordionSummary,
//   AccordionDetails,
//   Divider,
//   Chip,
//   Stack,
//   Table,
//   TableBody,
//   TableCell,
//   TableHead,
//   TableRow,
//   Paper,
//   IconButton,
//   Tooltip,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   TextField,
//   Grid,
//   Alert,
//   CircularProgress,
//   LinearProgress,
// } from '@mui/material';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import EditIcon from '@mui/icons-material/Edit';
// import DeleteIcon from '@mui/icons-material/Delete';
// import AddIcon from '@mui/icons-material/Add';
// import AutorenewIcon from '@mui/icons-material/Autorenew';
// import SecurityIcon from '@mui/icons-material/Security';
// import LockOpenIcon from '@mui/icons-material/LockOpen';
// import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
// import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import { API_BASE } from '../services/api';

// interface ParamMeta {
//   type: string;
//   required?: boolean;
//   constraints?: Record<string, any>;
//   default?: any;
//   description: string;
//   example?: any;
// }

// interface MCPFunction {
//   func_key: string;
//   display_name: string;
//   description: string;
//   method: string;
//   tags: string[];
//   input_schema: Record<string, ParamMeta>;
//   output_schema: Record<string, ParamMeta>;
//   additional_prompt: string;
// }

// interface ModuleDetail {
//   module_key: string;
//   description: string;
//   endpoint_prefix: string;
//   tags: any;
//   owner_user_id?: string | null;
//   auto_approve?: boolean;
// }

// type FuncFormMode = 'create' | 'edit';
// type MyAccessStatus = 'none' | 'requested' | 'approved';

// export default function MCPMDetail() {
//   const { module_key } = useParams<{ module_key: string }>();
//   const navigate = useNavigate();

//   const [module, setModule] = useState<ModuleDetail | null>(null);
//   const [functions, setFunctions] = useState<MCPFunction[]>([]);
//   const [error, setError] = useState<string | null>(null);

//   // 로딩 상태
//   const [moduleLoading, setModuleLoading] = useState<boolean>(false);
//   const [functionsLoading, setFunctionsLoading] = useState<boolean>(false);

//   // 내 접근 상태
//   const [accessStatus, setAccessStatus] = useState<MyAccessStatus>('none');
//   const [accessLoading, setAccessLoading] = useState<boolean>(false);
//   const [accessBusy, setAccessBusy] = useState<boolean>(false);

//   // 다이얼로그 상태
//   const [funcDialogOpen, setFuncDialogOpen] = useState(false);
//   const [funcDialogMode, setFuncDialogMode] = useState<FuncFormMode>('create');
//   const [editingFuncKey, setEditingFuncKey] = useState<string | null>(null);
//   const [formError, setFormError] = useState<string | null>(null);

//   // 함수 폼 상태
//   const [funcKey, setFuncKey] = useState('');
//   const [displayName, setDisplayName] = useState('');
//   const [method, setMethod] = useState('POST');
//   const [description, setDescription] = useState('');
//   const [tags, setTags] = useState<string[]>([]);
//   const [tagInput, setTagInput] = useState('');
//   const [tagError, setTagError] = useState<string | null>(null);
//   const [inputSchemaText, setInputSchemaText] = useState('{}');
//   const [outputSchemaText, setOutputSchemaText] = useState('{}');
//   const [additionalPrompt, setAdditionalPrompt] = useState('');

//   const authHeaders = useMemo(
//     () => ({
//       'x-user-id': localStorage.getItem('user_id') || '',
//       'x-access-token': localStorage.getItem('access_token') || '',
//       'x-refresh-token': localStorage.getItem('refresh_token') || '',
//     }),
//     []
//   );

//   const userId = useMemo(() => localStorage.getItem('user_id') || '', []);
//   const userTier = useMemo(() => {
//     const t = localStorage.getItem("user_tier");
//     return t ? parseInt(t, 10) : 2; // 기본값 2 (Builder)
//   }, []);

//   // 권한 체크: Admin(0) 혹은 본인(1)만 편집 가능 (Builder(2)는 불가)
//   const isOwnerOrAdmin = useMemo(() => {
//     if (!module) return false;
//     if (userTier >= 2) return false;
//     return module.owner_user_id === userId || userTier === 0;
//   }, [module, userId, userTier]);

//   const normalizeTags = (t: any): string[] => {
//     if (!t && t !== 0) return [];
//     if (Array.isArray(t)) return t.map(String);
//     if (typeof t === 'string') {
//       try {
//         const parsed = JSON.parse(t);
//         if (Array.isArray(parsed)) return parsed.map(String);
//       } catch {
//         const parts = t.split(',').map((s) => s.trim()).filter(Boolean);
//         return parts;
//       }
//       return t ? [t] : [];
//     }
//     return [String(t)];
//   };

//   const LoadingBanner = (props: { text: string }) => (
//     <Paper variant="outlined" sx={{ mb: 2, bgcolor: "#1e1e1e" }}>
//       <Box sx={{ p: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
//         <CircularProgress size={20} />
//         <Typography color="#ccc">{props.text}</Typography>
//       </Box>
//       <LinearProgress />
//     </Paper>
//   );

//   const fetchModule = () => {
//     if (!module_key) return;
//     setModuleLoading(true);
//     setError(null);
//     axios
//       .get(`${API_BASE}mcp-modules/${module_key}`, { headers: authHeaders })
//       .then((res) => {
//         if (res.data?.success) {
//           const mod: ModuleDetail = res.data.data?.module || res.data.data;
//           if (mod && (mod as any).module_key) {
//             const fixed: ModuleDetail = {
//               ...mod,
//               tags: normalizeTags((mod as any).tags),
//               auto_approve: typeof (mod as any).auto_approve === 'boolean' ? (mod as any).auto_approve : false,
//             };
//             setModule(fixed);
//           } else {
//             setError('모듈 정보를 찾을 수 없습니다.');
//           }
//         } else {
//           setError(res.data?.message || '모듈 조회 실패');
//         }
//       })
//       .catch(() => setError('모듈 정보를 불러오는 중 오류 발생'))
//       .finally(() => setModuleLoading(false));
//   };

//   const fetchFunctions = () => {
//     if (!module_key) return;
//     setFunctionsLoading(true);
//     setError(null);
//     axios
//       .get(`${API_BASE}mcp-functions/${module_key}`, { headers: authHeaders })
//       .then((res) => {
//         if (res.data.success) {
//           setFunctions(res.data.data.functions || []);
//         } else {
//           setError(res.data.message || '함수 목록 조회 실패');
//         }
//       })
//       .catch(() => setError('함수 목록을 불러오는 중 오류 발생'))
//       .finally(() => setFunctionsLoading(false));
//   };

//   const fetchMyAccessStatus = async () => {
//     if (!module_key) return;
//     setAccessLoading(true);
//     try {
//       const [reqRes, apprRes] = await Promise.all([
//         axios.get(`${API_BASE}mcp/me/access`, { headers: authHeaders, params: { status: 'requested' } }),
//         axios.get(`${API_BASE}mcp/me/access`, { headers: authHeaders, params: { status: 'approved' } }),
//       ]);
//       const requested: any[] = reqRes.data?.success ? reqRes.data.data || [] : [];
//       const approved: any[] = apprRes.data?.success ? apprRes.data.data || [] : [];

//       const reqHit = requested.some((r) => (r.module_key || '').toLowerCase() === String(module_key).toLowerCase());
//       const apprHit = approved.some((a) => (a.module_key || '').toLowerCase() === String(module_key).toLowerCase());

//       setAccessStatus(apprHit ? 'approved' : reqHit ? 'requested' : 'none');
//     } catch {
//       setAccessStatus('none');
//     } finally {
//       setAccessLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (!module_key) return;
//     fetchModule();
//     fetchFunctions();
//     fetchMyAccessStatus();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [module_key]);

//   const requestAccess = async () => {
//     if (!module_key) return;
//     if (!window.confirm('이 MCP에 접근을 요청할까요?')) return;
//     setAccessBusy(true);
//     try {
//       const res = await axios.post(
//         `${API_BASE}mcp/me/access/${encodeURIComponent(module_key)}/request`,
//         {},
//         { headers: authHeaders }
//       );
//       if (res.data?.success) {
//         await fetchMyAccessStatus();
//       } else {
//         alert(res.data?.message || '접근 요청에 실패했습니다.');
//       }
//     } catch (e: any) {
//       alert(e?.response?.data?.message || e?.message || '접근 요청 중 오류가 발생했습니다.');
//     } finally {
//       setAccessBusy(false);
//     }
//   };

//   const cancelRequest = async () => {
//     if (!module_key) return;
//     if (!window.confirm('보낸 접근 요청을 취소할까요?')) return;
//     setAccessBusy(true);
//     try {
//       const res = await axios.delete(
//         `${API_BASE}mcp/me/access/${encodeURIComponent(module_key)}/request`,
//         { headers: authHeaders }
//       );
//       if (res.data?.success) {
//         await fetchMyAccessStatus();
//       } else {
//         alert(res.data?.message || '요청 취소에 실패했습니다.');
//       }
//     } catch (e: any) {
//       alert(e?.response?.data?.message || e?.message || '요청 취소 중 오류가 발생했습니다.');
//     } finally {
//       setAccessBusy(false);
//     }
//   };

//   const leaveAccess = async () => {
//     if (!module_key) return;
//     if (!window.confirm('이 MCP 접근 권한을 해지(탈퇴)할까요?')) return;
//     setAccessBusy(true);
//     try {
//       const res = await axios.delete(
//         `${API_BASE}mcp/me/access/${encodeURIComponent(module_key)}/access`,
//         { headers: authHeaders }
//       );
//       if (res.data?.success) {
//         await fetchMyAccessStatus();
//       } else {
//         alert(res.data?.message || '접근 해지에 실패했습니다.');
//       }
//     } catch (e: any) {
//       alert(e?.response?.data?.message || e?.message || '접근 해지 중 오류가 발생했습니다.');
//     } finally {
//       setAccessBusy(false);
//     }
//   };

//   const addTag = (raw: string) => {
//     setTagError(null);
//     const val = raw.trim();
//     if (!val) return;
//     if (tags.length >= 10) {
//       setTagError('태그는 최대 10개까지 입력 가능합니다.');
//       return;
//     }
//     if (val.length > 40) {
//       setTagError('태그는 최대 40자까지 가능합니다.');
//       return;
//     }
//     const normalized = val.replace(/\s+/g, '-');
//     if (tags.some((t) => t.toLowerCase() === normalized.toLowerCase())) {
//       setTagError('중복 태그입니다.');
//       return;
//     }
//     setTags((prev) => [...prev, normalized]);
//   };
//   const handleTagKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
//     if (e.key === 'Enter' || e.key === ',' || e.key === 'Tab') {
//       e.preventDefault();
//       if (tagInput.trim()) {
//         addTag(tagInput);
//         setTagInput('');
//       }
//     }
//   };
//   const handleTagBlur = () => {
//     if (tagInput.trim()) {
//       addTag(tagInput);
//       setTagInput('');
//     }
//   };
//   const removeTag = (idx: number) => {
//     setTags((prev) => prev.filter((_, i) => i !== idx));
//     setTagError(null);
//   };

//   const openCreateFunc = () => {
//     setFuncDialogMode('create');
//     setEditingFuncKey(null);
//     setFormError(null);
//     setFuncKey('');
//     setDisplayName('');
//     setMethod('POST');
//     setDescription('');
//     setTags([]);
//     setTagInput('');
//     setTagError(null);
//     setInputSchemaText('{}');
//     setOutputSchemaText('{}');
//     setAdditionalPrompt('');
//     setFuncDialogOpen(true);
//   };

//   const isJsonObject = (v: any) => typeof v === 'object' && v !== null && !Array.isArray(v);

//   const openEditFunc = (fn: MCPFunction) => {
//     if (!isOwnerOrAdmin) return;
//     setFuncDialogMode('edit');
//     setEditingFuncKey(fn.func_key);
//     setFormError(null);
//     setFuncKey(fn.func_key);
//     setDisplayName(fn.display_name);
//     setMethod(fn.method);
//     setDescription(fn.description);
//     setTags(fn.tags || []);
//     setTagInput('');
//     setTagError(null);
//     setInputSchemaText(JSON.stringify(isJsonObject(fn.input_schema) ? fn.input_schema : {}, null, 2));
//     setOutputSchemaText(JSON.stringify(isJsonObject(fn.output_schema) ? fn.output_schema : {}, null, 2));
//     setAdditionalPrompt(fn.additional_prompt || '');
//     setFuncDialogOpen(true);
//   };

//   const closeFuncDialog = () => setFuncDialogOpen(false);

//   const parseJsonOrError = (text: string, label: string) => {
//     try {
//       const obj = JSON.parse(text || '{}');
//       if (!isJsonObject(obj)) throw new Error(`${label}는 객체 형태여야 합니다.`);
//       return obj;
//     } catch (e: any) {
//       throw new Error(`${label} JSON 파싱 오류: ${e.message}`);
//     }
//   };

//   const submitFunc = () => {
//     setFormError(null);
//     const mk = (module_key || '').trim();
//     const fk = funcKey.trim();

//     if (!fk) return setFormError('func_key를 입력하세요.');
//     if (!/^[a-z0-9_\-]+$/i.test(fk)) return setFormError('func_key는 영문/숫자/언더스코어/하이픈만 허용됩니다.');
//     if (!displayName.trim()) return setFormError('display_name을 입력하세요.');
//     if (!method.trim()) return setFormError('method를 입력하세요. (예: GET/POST/PUT/DELETE)');

//     let inputSchema: Record<string, ParamMeta>;
//     let outputSchema: Record<string, ParamMeta>;
//     try {
//       inputSchema = parseJsonOrError(inputSchemaText, 'Input Schema');
//       outputSchema = parseJsonOrError(outputSchemaText, 'Output Schema');
//     } catch (e: any) {
//       setFormError(e.message);
//       return;
//     }

//     const payload = {
//       func_key: fk,
//       display_name: displayName,
//       description: description || '',
//       method: method.toUpperCase(),
//       tags: tags,
//       input_schema: inputSchema,
//       output_schema: outputSchema,
//       additional_prompt: additionalPrompt || '',
//     };

//     if (funcDialogMode === 'create') {
//       axios
//         .post(`${API_BASE}mcp-functions/${mk}`, payload, { headers: authHeaders })
//         .then((res) => {
//           if (res.data.success) {
//             closeFuncDialog();
//             fetchFunctions();
//           } else {
//             setFormError(res.data.message || '함수 생성 실패');
//           }
//         })
//         .catch(() => setFormError('함수 생성 중 오류가 발생했습니다.'));
//     } else {
//       const targetKey = editingFuncKey!;
//       axios
//         .put(`${API_BASE}mcp-functions/${mk}/${encodeURIComponent(targetKey)}`, payload, {
//           headers: authHeaders,
//         })
//         .then((res) => {
//           if (res.data.success) {
//             closeFuncDialog();
//             fetchFunctions();
//           } else {
//             setFormError(res.data.message || '함수 수정 실패');
//           }
//         })
//         .catch(() => setFormError('함수 수정 중 오류가 발생했습니다.'));
//     }
//   };

//   const handleDeleteModule = () => {
//     if (!module_key) return;
//     if (!window.confirm('정말 이 모듈을 전체 삭제하시겠습니까? (함수 포함)')) return;
//     axios
//       .delete(`${API_BASE}mcp-modules/${module_key}`, { headers: authHeaders })
//       .then((res) => {
//         if (res.data.success) {
//           navigate(-1);
//         } else {
//           setError(res.data.message || '삭제 실패');
//         }
//       })
//       .catch(() => setError('삭제 중 오류 발생'));
//   };

//   if (error) return (
//     <Box sx={{ p: 4, textAlign: "center" }}>
//       <Typography variant="h6" color="error" gutterBottom>오류 발생</Typography>
//       <Typography color="text.secondary">{error}</Typography>
//       <Button variant="outlined" sx={{ mt: 2 }} onClick={() => navigate(-1)}>뒤로 가기</Button>
//     </Box>
//   );

//   if (moduleLoading || !module) {
//     return (
//       <Box sx={{ p: 2 }}>
//         <LoadingBanner text="모듈 정보를 불러오는 중..." />
//       </Box>
//     );
//   }

//   const AccessStatusChip = () => {
//     if (accessLoading) {
//       return (
//         <Chip
//           size="small"
//           icon={<HourglassEmptyIcon fontSize="small" />}
//           label="확인 중..."
//           variant="outlined"
//           sx={{ borderColor: '#666', color: '#aaa' }}
//         />
//       );
//     }
//     if (accessStatus === 'approved') {
//       return (
//         <Chip
//           size="small"
//           color="success"
//           icon={<LockOpenIcon fontSize="small" />}
//           label="승인됨"
//           variant="filled"
//         />
//       );
//     }
//     if (accessStatus === 'requested') {
//       return (
//         <Chip
//           size="small"
//           color="warning"
//           icon={<HourglassEmptyIcon fontSize="small" />}
//           label="승인 대기"
//           variant="filled"
//         />
//       );
//     }
//     return (
//       <Chip
//         size="small"
//         variant="outlined"
//         color="default"
//         icon={<SecurityIcon fontSize="small" />}
//         label="권한 없음"
//         sx={{ borderColor: '#666', color: '#aaa' }}
//       />
//     );
//   };

//   const AccessActionButton = () => {
//     if (accessLoading) {
//       return <Button size="small" variant="outlined" disabled>확인 중...</Button>;
//     }
//     if (accessStatus === 'approved') {
//       return (
//         <Button
//           size="small"
//           variant="outlined"
//           color="error"
//           onClick={leaveAccess}
//           disabled={accessBusy}
//         >
//           {accessBusy ? '처리 중...' : '접근 해지'}
//         </Button>
//       );
//     }
//     if (accessStatus === 'requested') {
//       return (
//         <Button
//           size="small"
//           variant="outlined"
//           color="inherit"
//           onClick={cancelRequest}
//           disabled={accessBusy}
//           sx={{ borderColor: '#666', color: '#ccc' }}
//         >
//           {accessBusy ? '처리 중...' : '요청 취소'}
//         </Button>
//       );
//     }
//     return (
//       <Button
//         size="small"
//         variant="contained"
//         onClick={requestAccess}
//         disabled={accessBusy}
//       >
//         {accessBusy ? '요청 중...' : '접근 요청'}
//       </Button>
//     );
//   };

//   return (
//     <Box sx={{ p: 3 }}>
//       {(moduleLoading || functionsLoading) && (
//         <LoadingBanner text="데이터를 불러오는 중..." />
//       )}

//       {/* 상단 네비게이션 및 타이틀 */}
//       <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
//         <Stack direction="row" spacing={2} alignItems="center">
//           <IconButton onClick={() => navigate(-1)} sx={{ color: "#fff" }}>
//             <ArrowBackIcon />
//           </IconButton>
//           <Box>
//             <Typography variant="h5" fontWeight="bold" color="#fff">
//               {module.module_key}
//             </Typography>
//             <Typography variant="body2" color="grey.500">
//               {module.endpoint_prefix}
//             </Typography>
//           </Box>
//         </Stack>
        
//         <Stack direction="row" spacing={1}>
//           {isOwnerOrAdmin && (
//             <>
//               <Button variant="outlined" color="primary" onClick={() => navigate(`/mcp/${module_key}/edit`)}>
//                 전체 편집
//               </Button>
//               <Button variant="outlined" color="error" onClick={handleDeleteModule}>
//                 전체 삭제
//               </Button>
//             </>
//           )}
//         </Stack>
//       </Box>

//       {/* 모듈 상세 정보 카드 */}
//       <Paper variant="outlined" sx={{ p: 3, mb: 3, bgcolor: "#1e1e1e", borderRadius: 2 }}>
//         <Grid container spacing={3}>
//           <Grid item xs={12} md={8}>
//             <Typography variant="subtitle1" fontWeight="bold" color="#fff" gutterBottom>
//               Description
//             </Typography>
//             <Typography variant="body1" color="grey.300" paragraph>
//               {module.description || "설명이 없습니다."}
//             </Typography>

//             <Divider sx={{ my: 2, borderColor: "#333" }} />

//             <Stack direction="row" spacing={1} alignItems="center">
//               <Typography variant="caption" color="grey.500">TAGS:</Typography>
//               {normalizeTags(module.tags).length > 0 ? (
//                 normalizeTags(module.tags).map((t, i) => (
//                   <Chip key={i} size="small" label={t} sx={{ bgcolor: "rgba(255,255,255,0.1)", color: "#ddd" }} />
//                 ))
//               ) : (
//                 <Typography variant="caption" color="grey.600">없음</Typography>
//               )}
//             </Stack>
//           </Grid>

//           <Grid item xs={12} md={4}>
//             <Paper elevation={0} sx={{ p: 2, bgcolor: "rgba(0,0,0,0.3)", borderRadius: 2 }}>
//               <Stack spacing={2}>
//                 <Box display="flex" justifyContent="space-between">
//                   <Typography variant="body2" color="grey.400">Owner</Typography>
//                   <Typography variant="body2" color="#fff" fontWeight="bold">{module.owner_user_id || "—"}</Typography>
//                 </Box>
//                 <Box display="flex" justifyContent="space-between">
//                   <Typography variant="body2" color="grey.400">Auto Approve</Typography>
//                   <Chip
//                     size="small"
//                     label={module.auto_approve ? 'ON' : 'OFF'}
//                     color={module.auto_approve ? 'success' : 'default'}
//                     variant="outlined"
//                     sx={{ height: 20 }}
//                   />
//                 </Box>
//                 <Divider sx={{ borderColor: "#444" }} />
//                 <Box display="flex" justifyContent="space-between" alignItems="center">
//                   <Typography variant="body2" color="grey.400">My Access</Typography>
//                   <AccessStatusChip />
//                 </Box>
//                 <Box pt={1}>
//                   <AccessActionButton />
//                 </Box>
//               </Stack>
//             </Paper>
//           </Grid>
//         </Grid>
//       </Paper>

//       {/* 함수 목록 섹션 */}
//       <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
//         <Typography variant="h6" color="#fff" fontWeight="bold">
//           Functions ({functions.length})
//         </Typography>
//         {isOwnerOrAdmin && (
//           <Button variant="contained" startIcon={<AddIcon />} onClick={openCreateFunc}>
//             함수 추가
//           </Button>
//         )}
//       </Box>

//       {/* 함수 목록 로딩 */}
//       {functionsLoading && (
//         <Paper variant="outlined" sx={{ p: 3, bgcolor: '#1e1e1e', display: 'flex', gap: 2, alignItems: 'center' }}>
//           <CircularProgress size={24} />
//           <Typography color="grey.500">함수 목록을 불러오는 중...</Typography>
//         </Paper>
//       )}

//       {/* 함수 목록이 비었을 때 */}
//       {!functionsLoading && functions.length === 0 && (
//         <Paper variant="outlined" sx={{ p: 6, textAlign: 'center', bgcolor: '#1e1e1e', color: '#666' }}>
//           등록된 함수가 없습니다.
//         </Paper>
//       )}

//       {/* 함수 리스트 (Accordion) */}
//       {!functionsLoading && functions.map((fn) => (
//         <Accordion key={fn.func_key} sx={{ bgcolor: '#252525', color: '#fff', mb: 1, '&:before': { display: 'none' } }}>
//           <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#fff' }} />}>
//             <Grid container alignItems="center" spacing={2}>
//               <Grid item>
//                 <Chip
//                   label={fn.method}
//                   size="small"
//                   variant="outlined"
//                   color={fn.method === 'GET' ? 'info' : fn.method === 'POST' ? 'success' : 'default'}
//                   sx={{ fontWeight: 'bold', minWidth: 60 }}
//                 />
//               </Grid>
//               <Grid item xs>
//                 <Typography fontWeight="bold">{fn.func_key}</Typography>
//                 <Typography variant="caption" color="grey.400">{fn.display_name}</Typography>
//               </Grid>
//               {isOwnerOrAdmin && (
//                 <Grid item>
//                   <IconButton size="small" onClick={(e) => { e.stopPropagation(); openEditFunc(fn); }} sx={{ color: '#aaa' }}>
//                     <EditIcon fontSize="small" />
//                   </IconButton>
//                   <IconButton size="small" onClick={(e) => {
//                     e.stopPropagation();
//                     if (window.confirm(`함수 "${fn.func_key}"를 삭제하시겠습니까?`)) {
//                       axios.delete(`${API_BASE}mcp-functions/${module_key}/${encodeURIComponent(fn.func_key)}`, { headers: authHeaders })
//                         .then((res) => {
//                           if (res.data.success) fetchFunctions();
//                           else setError(res.data.message);
//                         });
//                     }
//                   }} sx={{ color: '#f44336' }}>
//                     <DeleteIcon fontSize="small" />
//                   </IconButton>
//                 </Grid>
//               )}
//             </Grid>
//           </AccordionSummary>
//           <AccordionDetails sx={{ bgcolor: '#1e1e1e', borderTop: '1px solid #333' }}>
//             <Typography variant="body2" color="grey.300" paragraph>
//               {fn.description || "설명이 없습니다."}
//             </Typography>
            
//             <Grid container spacing={2}>
//               <Grid item xs={12} md={6}>
//                 <Typography variant="caption" color="grey.500" gutterBottom>INPUT SCHEMA</Typography>
//                 <Paper variant="outlined" sx={{ bgcolor: 'rgba(0,0,0,0.2)', p: 0, overflow: 'hidden' }}>
//                   <Table size="small">
//                     <TableHead sx={{ bgcolor: '#333' }}>
//                       <TableRow>
//                         <TableCell sx={{ color: '#ccc', py: 0.5 }}>Name</TableCell>
//                         <TableCell sx={{ color: '#ccc', py: 0.5 }}>Type</TableCell>
//                         <TableCell sx={{ color: '#ccc', py: 0.5 }}>Desc</TableCell>
//                       </TableRow>
//                     </TableHead>
//                     <TableBody>
//                       {Object.keys(fn.input_schema || {}).length === 0 ? (
//                         <TableRow><TableCell colSpan={3} sx={{ color: '#666', textAlign: 'center' }}>No Input</TableCell></TableRow>
//                       ) : (
//                         Object.entries(fn.input_schema || {}).map(([key, meta]) => (
//                           <TableRow key={key}>
//                             <TableCell sx={{ color: '#fff' }}>{key} {(meta as any).required && '*'}</TableCell>
//                             <TableCell sx={{ color: '#aaa' }}>{(meta as any).type}</TableCell>
//                             <TableCell sx={{ color: '#aaa' }}>{(meta as any).description}</TableCell>
//                           </TableRow>
//                         ))
//                       )}
//                     </TableBody>
//                   </Table>
//                 </Paper>
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <Typography variant="caption" color="grey.500" gutterBottom>OUTPUT SCHEMA</Typography>
//                 <Paper variant="outlined" sx={{ bgcolor: 'rgba(0,0,0,0.2)', p: 0, overflow: 'hidden' }}>
//                   <Table size="small">
//                     <TableHead sx={{ bgcolor: '#333' }}>
//                       <TableRow>
//                         <TableCell sx={{ color: '#ccc', py: 0.5 }}>Name</TableCell>
//                         <TableCell sx={{ color: '#ccc', py: 0.5 }}>Type</TableCell>
//                         <TableCell sx={{ color: '#ccc', py: 0.5 }}>Desc</TableCell>
//                       </TableRow>
//                     </TableHead>
//                     <TableBody>
//                       {Object.keys(fn.output_schema || {}).length === 0 ? (
//                         <TableRow><TableCell colSpan={3} sx={{ color: '#666', textAlign: 'center' }}>No Output</TableCell></TableRow>
//                       ) : (
//                         Object.entries(fn.output_schema || {}).map(([key, meta]) => (
//                           <TableRow key={key}>
//                             <TableCell sx={{ color: '#fff' }}>{key}</TableCell>
//                             <TableCell sx={{ color: '#aaa' }}>{(meta as any).type}</TableCell>
//                             <TableCell sx={{ color: '#aaa' }}>{(meta as any).description}</TableCell>
//                           </TableRow>
//                         ))
//                       )}
//                     </TableBody>
//                   </Table>
//                 </Paper>
//               </Grid>
//             </Grid>

//             {fn.additional_prompt && (
//               <Box mt={2}>
//                 <Typography variant="caption" color="grey.500">ADDITIONAL PROMPT</Typography>
//                 <Paper variant="outlined" sx={{ p: 1.5, bgcolor: '#111', color: '#ccc', fontSize: '0.85rem', fontFamily: 'monospace' }}>
//                   {fn.additional_prompt}
//                 </Paper>
//               </Box>
//             )}
//           </AccordionDetails>
//         </Accordion>
//       ))}

//       {/* 함수 추가/편집 다이얼로그 */}
//       <Dialog 
//         open={funcDialogOpen} 
//         onClose={closeFuncDialog} 
//         maxWidth="md" 
//         fullWidth
//         PaperProps={{ sx: { bgcolor: "#1e1e1e", color: "#fff" } }}
//       >
//         <DialogTitle sx={{ borderBottom: "1px solid #333" }}>
//           {funcDialogMode === 'create' ? '함수 추가' : `함수 편집 (${editingFuncKey})`}
//         </DialogTitle>
//         <DialogContent sx={{ mt: 2 }}>
//           {formError && (
//             <Alert severity="error" sx={{ mb: 2 }}>{formError}</Alert>
//           )}

//           <Grid container spacing={2}>
//             <Grid item xs={12} md={6}>
//               <TextField
//                 label="Function Key (ID)"
//                 value={funcKey}
//                 onChange={(e) => setFuncKey(e.target.value)}
//                 fullWidth
//                 disabled={funcDialogMode === 'edit'}
//                 helperText="영문, 숫자, 언더스코어(_)만 사용 가능"
//                 InputLabelProps={{ style: { color: "#aaa" } }}
//                 InputProps={{ style: { color: "#fff" }, sx: { ".MuiOutlinedInput-notchedOutline": { borderColor: "#555" } } }}
//               />
//             </Grid>
//             <Grid item xs={12} md={6}>
//               <TextField
//                 label="Display Name"
//                 value={displayName}
//                 onChange={(e) => setDisplayName(e.target.value)}
//                 fullWidth
//                 InputLabelProps={{ style: { color: "#aaa" } }}
//                 InputProps={{ style: { color: "#fff" }, sx: { ".MuiOutlinedInput-notchedOutline": { borderColor: "#555" } } }}
//               />
//             </Grid>
//             <Grid item xs={12} md={6}>
//               <TextField
//                 label="Method"
//                 value={method}
//                 onChange={(e) => setMethod(e.target.value)}
//                 fullWidth
//                 helperText="예: POST, GET"
//                 InputLabelProps={{ style: { color: "#aaa" } }}
//                 InputProps={{ style: { color: "#fff" }, sx: { ".MuiOutlinedInput-notchedOutline": { borderColor: "#555" } } }}
//               />
//             </Grid>
//             <Grid item xs={12} md={6}>
//               <TextField
//                 label="Description"
//                 value={description}
//                 onChange={(e) => setDescription(e.target.value)}
//                 fullWidth
//                 InputLabelProps={{ style: { color: "#aaa" } }}
//                 InputProps={{ style: { color: "#fff" }, sx: { ".MuiOutlinedInput-notchedOutline": { borderColor: "#555" } } }}
//               />
//             </Grid>

//             {/* 태그 입력 */}
//             <Grid item xs={12}>
//               <Typography variant="caption" color="grey.500" sx={{ mb: 1, display: "block" }}>
//                 Tags (Enter로 추가)
//               </Typography>
//               <TextField
//                 size="small"
//                 value={tagInput}
//                 onChange={(e) => setTagInput(e.target.value)}
//                 onKeyDown={handleTagKeyDown}
//                 onBlur={handleTagBlur}
//                 fullWidth
//                 error={!!tagError}
//                 helperText={tagError}
//                 InputProps={{ style: { color: "#fff" }, sx: { ".MuiOutlinedInput-notchedOutline": { borderColor: "#555" } } }}
//               />
//               <Stack direction="row" spacing={1} flexWrap="wrap" sx={{ mt: 1 }}>
//                 {tags.map((t, i) => (
//                   <Chip key={i} label={t} onDelete={() => removeTag(i)} size="small" sx={{ bgcolor: "#333", color: "#fff" }} />
//                 ))}
//               </Stack>
//             </Grid>

//             {/* JSON Schema Inputs */}
//             <Grid item xs={12} md={6}>
//               <TextField
//                 label="Input Schema (JSON)"
//                 value={inputSchemaText}
//                 onChange={(e) => setInputSchemaText(e.target.value)}
//                 fullWidth
//                 multiline
//                 minRows={6}
//                 InputLabelProps={{ style: { color: "#aaa" } }}
//                 InputProps={{ 
//                   style: { color: "#fff", fontFamily: "monospace", fontSize: "0.85rem" }, 
//                   sx: { ".MuiOutlinedInput-notchedOutline": { borderColor: "#555" } } 
//                 }}
//               />
//             </Grid>
//             <Grid item xs={12} md={6}>
//               <TextField
//                 label="Output Schema (JSON)"
//                 value={outputSchemaText}
//                 onChange={(e) => setOutputSchemaText(e.target.value)}
//                 fullWidth
//                 multiline
//                 minRows={6}
//                 InputLabelProps={{ style: { color: "#aaa" } }}
//                 InputProps={{ 
//                   style: { color: "#fff", fontFamily: "monospace", fontSize: "0.85rem" }, 
//                   sx: { ".MuiOutlinedInput-notchedOutline": { borderColor: "#555" } } 
//                 }}
//               />
//             </Grid>

//             <Grid item xs={12}>
//               <TextField
//                 label="Additional Prompt"
//                 value={additionalPrompt}
//                 onChange={(e) => setAdditionalPrompt(e.target.value)}
//                 fullWidth
//                 multiline
//                 minRows={3}
//                 placeholder="LLM에게 전달할 추가 지침을 입력하세요."
//                 InputLabelProps={{ style: { color: "#aaa" } }}
//                 InputProps={{ style: { color: "#fff" }, sx: { ".MuiOutlinedInput-notchedOutline": { borderColor: "#555" } } }}
//               />
//             </Grid>
//           </Grid>
//         </DialogContent>
//         <DialogActions sx={{ p: 2, borderTop: "1px solid #333" }}>
//           <Button onClick={closeFuncDialog} sx={{ color: "#aaa" }}>취소</Button>
//           <Button variant="contained" onClick={submitFunc}>저장</Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// }


import React, { useEffect, useMemo, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import {
  Box,
  Typography,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Divider,
  Chip,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Grid,
  Alert,
  CircularProgress,
  LinearProgress,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import SecurityIcon from '@mui/icons-material/Security';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { API_BASE } from '../services/api';

interface ParamMeta {
  type: string;
  required?: boolean;
  constraints?: Record<string, any>;
  default?: any;
  description: string;
  example?: any;
}

interface MCPFunction {
  func_key: string;
  display_name: string;
  description: string;
  method: string;
  tags: string[];
  input_schema: Record<string, ParamMeta>;
  output_schema: Record<string, ParamMeta>;
  additional_prompt: string;
}

interface ModuleDetail {
  module_key: string;
  description: string;
  endpoint_prefix: string;
  tags: any;
  owner_user_id?: string | null;
  auto_approve?: boolean;
  org_id?: string; // ✅ [추가] 권한 판단을 위해 org_id 필수
}

type FuncFormMode = 'create' | 'edit';
type MyAccessStatus = 'none' | 'requested' | 'approved';

export default function MCPMDetail() {
  const { module_key } = useParams<{ module_key: string }>();
  const navigate = useNavigate();

  const [module, setModule] = useState<ModuleDetail | null>(null);
  const [functions, setFunctions] = useState<MCPFunction[]>([]);
  const [error, setError] = useState<string | null>(null);

  // 로딩 상태
  const [moduleLoading, setModuleLoading] = useState<boolean>(false);
  const [functionsLoading, setFunctionsLoading] = useState<boolean>(false);

  // 내 접근 상태
  const [accessStatus, setAccessStatus] = useState<MyAccessStatus>('none');
  const [accessLoading, setAccessLoading] = useState<boolean>(false);
  const [accessBusy, setAccessBusy] = useState<boolean>(false);

  // 다이얼로그 상태
  const [funcDialogOpen, setFuncDialogOpen] = useState(false);
  const [funcDialogMode, setFuncDialogMode] = useState<FuncFormMode>('create');
  const [editingFuncKey, setEditingFuncKey] = useState<string | null>(null);
  const [formError, setFormError] = useState<string | null>(null);

  // 함수 폼 상태
  const [funcKey, setFuncKey] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [method, setMethod] = useState('POST');
  const [description, setDescription] = useState('');
  const [tags, setTags] = useState<string[]>([]);
  const [tagInput, setTagInput] = useState('');
  const [tagError, setTagError] = useState<string | null>(null);
  const [inputSchemaText, setInputSchemaText] = useState('{}');
  const [outputSchemaText, setOutputSchemaText] = useState('{}');
  const [additionalPrompt, setAdditionalPrompt] = useState('');

  const authHeaders = useMemo(
    () => ({
      'x-user-id': localStorage.getItem('user_id') || '',
      'x-access-token': localStorage.getItem('access_token') || '',
      'x-refresh-token': localStorage.getItem('refresh_token') || '',
    }),
    []
  );

  const userId = useMemo(() => localStorage.getItem('user_id') || '', []);
  const userTier = useMemo(() => {
    const t = localStorage.getItem("user_tier");
    return t ? parseInt(t, 10) : 2; // 기본값 2 (Builder)
  }, []);

  // ✅ [수정] 권한 체크 로직 강화
  const isOwnerOrAdmin = useMemo(() => {
    if (!module) return false;
    
    // 1. Builder(Tier 2)는 절대 불가
    if (userTier >= 2) return false;

    // 2. 본인이 작성자(Owner)라면 무조건 가능
    if (module.owner_user_id === userId) return true;

    // 3. Admin(Tier 0)인 경우
    if (userTier === 0) {
        // 🚨 GLOBAL 모듈인 경우: 작성자가 아니면 Admin이라도 수정 불가
        // (KR 조직 어드민이 글로벌 공용 모듈을 지우면 안 되므로)
        if (module.org_id === '#GLOBAL#') return false;
        
        // 그 외(우리 조직 내부 모듈)라면 Admin 권한으로 수정 가능
        return true;
    }

    return false;
  }, [module, userId, userTier]);

  const normalizeTags = (t: any): string[] => {
    if (!t && t !== 0) return [];
    if (Array.isArray(t)) return t.map(String);
    if (typeof t === 'string') {
      try {
        const parsed = JSON.parse(t);
        if (Array.isArray(parsed)) return parsed.map(String);
      } catch {
        const parts = t.split(',').map((s) => s.trim()).filter(Boolean);
        return parts;
      }
      return t ? [t] : [];
    }
    return [String(t)];
  };

  const LoadingBanner = (props: { text: string }) => (
    <Paper variant="outlined" sx={{ mb: 2, bgcolor: "#1e1e1e" }}>
      <Box sx={{ p: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
        <CircularProgress size={20} />
        <Typography color="#ccc">{props.text}</Typography>
      </Box>
      <LinearProgress />
    </Paper>
  );

  const fetchModule = () => {
    if (!module_key) return;
    setModuleLoading(true);
    setError(null);
    axios
      .get(`${API_BASE}mcp-modules/${module_key}`, { headers: authHeaders })
      .then((res) => {
        if (res.data?.success) {
          const mod: ModuleDetail = res.data.data?.module || res.data.data;
          if (mod && (mod as any).module_key) {
            const fixed: ModuleDetail = {
              ...mod,
              tags: normalizeTags((mod as any).tags),
              auto_approve: typeof (mod as any).auto_approve === 'boolean' ? (mod as any).auto_approve : false,
            };
            setModule(fixed);
          } else {
            setError('모듈 정보를 찾을 수 없습니다.');
          }
        } else {
          setError(res.data?.message || '모듈 조회 실패');
        }
      })
      .catch(() => setError('모듈 정보를 불러오는 중 오류 발생'))
      .finally(() => setModuleLoading(false));
  };

  const fetchFunctions = () => {
    if (!module_key) return;
    setFunctionsLoading(true);
    setError(null);
    axios
      .get(`${API_BASE}mcp-functions/${module_key}`, { headers: authHeaders })
      .then((res) => {
        if (res.data.success) {
          setFunctions(res.data.data.functions || []);
        } else {
          setError(res.data.message || '함수 목록 조회 실패');
        }
      })
      .catch(() => setError('함수 목록을 불러오는 중 오류 발생'))
      .finally(() => setFunctionsLoading(false));
  };

  const fetchMyAccessStatus = async () => {
    if (!module_key) return;
    setAccessLoading(true);
    try {
      const [reqRes, apprRes] = await Promise.all([
        axios.get(`${API_BASE}mcp/me/access`, { headers: authHeaders, params: { status: 'requested' } }),
        axios.get(`${API_BASE}mcp/me/access`, { headers: authHeaders, params: { status: 'approved' } }),
      ]);
      const requested: any[] = reqRes.data?.success ? reqRes.data.data || [] : [];
      const approved: any[] = apprRes.data?.success ? apprRes.data.data || [] : [];

      const reqHit = requested.some((r) => (r.module_key || '').toLowerCase() === String(module_key).toLowerCase());
      const apprHit = approved.some((a) => (a.module_key || '').toLowerCase() === String(module_key).toLowerCase());

      setAccessStatus(apprHit ? 'approved' : reqHit ? 'requested' : 'none');
    } catch {
      setAccessStatus('none');
    } finally {
      setAccessLoading(false);
    }
  };

  useEffect(() => {
    if (!module_key) return;
    fetchModule();
    fetchFunctions();
    fetchMyAccessStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [module_key]);

  const requestAccess = async () => {
    if (!module_key) return;
    if (!window.confirm('이 MCP에 접근을 요청할까요?')) return;
    setAccessBusy(true);
    try {
      const res = await axios.post(
        `${API_BASE}mcp/me/access/${encodeURIComponent(module_key)}/request`,
        {},
        { headers: authHeaders }
      );
      if (res.data?.success) {
        await fetchMyAccessStatus();
      } else {
        alert(res.data?.message || '접근 요청에 실패했습니다.');
      }
    } catch (e: any) {
      alert(e?.response?.data?.message || e?.message || '접근 요청 중 오류가 발생했습니다.');
    } finally {
      setAccessBusy(false);
    }
  };

  const cancelRequest = async () => {
    if (!module_key) return;
    if (!window.confirm('보낸 접근 요청을 취소할까요?')) return;
    setAccessBusy(true);
    try {
      const res = await axios.delete(
        `${API_BASE}mcp/me/access/${encodeURIComponent(module_key)}/request`,
        { headers: authHeaders }
      );
      if (res.data?.success) {
        await fetchMyAccessStatus();
      } else {
        alert(res.data?.message || '요청 취소에 실패했습니다.');
      }
    } catch (e: any) {
      alert(e?.response?.data?.message || e?.message || '요청 취소 중 오류가 발생했습니다.');
    } finally {
      setAccessBusy(false);
    }
  };

  const leaveAccess = async () => {
    if (!module_key) return;
    if (!window.confirm('이 MCP 접근 권한을 해지(탈퇴)할까요?')) return;
    setAccessBusy(true);
    try {
      const res = await axios.delete(
        `${API_BASE}mcp/me/access/${encodeURIComponent(module_key)}/access`,
        { headers: authHeaders }
      );
      if (res.data?.success) {
        await fetchMyAccessStatus();
      } else {
        alert(res.data?.message || '접근 해지에 실패했습니다.');
      }
    } catch (e: any) {
      alert(e?.response?.data?.message || e?.message || '접근 해지 중 오류가 발생했습니다.');
    } finally {
      setAccessBusy(false);
    }
  };

  const addTag = (raw: string) => {
    setTagError(null);
    const val = raw.trim();
    if (!val) return;
    if (tags.length >= 10) {
      setTagError('태그는 최대 10개까지 입력 가능합니다.');
      return;
    }
    if (val.length > 40) {
      setTagError('태그는 최대 40자까지 가능합니다.');
      return;
    }
    const normalized = val.replace(/\s+/g, '-');
    if (tags.some((t) => t.toLowerCase() === normalized.toLowerCase())) {
      setTagError('중복 태그입니다.');
      return;
    }
    setTags((prev) => [...prev, normalized]);
  };
  const handleTagKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' || e.key === ',' || e.key === 'Tab') {
      e.preventDefault();
      if (tagInput.trim()) {
        addTag(tagInput);
        setTagInput('');
      }
    }
  };
  const handleTagBlur = () => {
    if (tagInput.trim()) {
      addTag(tagInput);
      setTagInput('');
    }
  };
  const removeTag = (idx: number) => {
    setTags((prev) => prev.filter((_, i) => i !== idx));
    setTagError(null);
  };

  const openCreateFunc = () => {
    setFuncDialogMode('create');
    setEditingFuncKey(null);
    setFormError(null);
    setFuncKey('');
    setDisplayName('');
    setMethod('POST');
    setDescription('');
    setTags([]);
    setTagInput('');
    setTagError(null);
    setInputSchemaText('{}');
    setOutputSchemaText('{}');
    setAdditionalPrompt('');
    setFuncDialogOpen(true);
  };

  const isJsonObject = (v: any) => typeof v === 'object' && v !== null && !Array.isArray(v);

  const openEditFunc = (fn: MCPFunction) => {
    if (!isOwnerOrAdmin) return;
    setFuncDialogMode('edit');
    setEditingFuncKey(fn.func_key);
    setFormError(null);
    setFuncKey(fn.func_key);
    setDisplayName(fn.display_name);
    setMethod(fn.method);
    setDescription(fn.description);
    setTags(fn.tags || []);
    setTagInput('');
    setTagError(null);
    setInputSchemaText(JSON.stringify(isJsonObject(fn.input_schema) ? fn.input_schema : {}, null, 2));
    setOutputSchemaText(JSON.stringify(isJsonObject(fn.output_schema) ? fn.output_schema : {}, null, 2));
    setAdditionalPrompt(fn.additional_prompt || '');
    setFuncDialogOpen(true);
  };

  const closeFuncDialog = () => setFuncDialogOpen(false);

  const parseJsonOrError = (text: string, label: string) => {
    try {
      const obj = JSON.parse(text || '{}');
      if (!isJsonObject(obj)) throw new Error(`${label}는 객체 형태여야 합니다.`);
      return obj;
    } catch (e: any) {
      throw new Error(`${label} JSON 파싱 오류: ${e.message}`);
    }
  };

  const submitFunc = () => {
    setFormError(null);
    const mk = (module_key || '').trim();
    const fk = funcKey.trim();

    if (!fk) return setFormError('func_key를 입력하세요.');
    if (!/^[a-z0-9_\-]+$/i.test(fk)) return setFormError('func_key는 영문/숫자/언더스코어/하이픈만 허용됩니다.');
    if (!displayName.trim()) return setFormError('display_name을 입력하세요.');
    if (!method.trim()) return setFormError('method를 입력하세요. (예: GET/POST/PUT/DELETE)');

    let inputSchema: Record<string, ParamMeta>;
    let outputSchema: Record<string, ParamMeta>;
    try {
      inputSchema = parseJsonOrError(inputSchemaText, 'Input Schema');
      outputSchema = parseJsonOrError(outputSchemaText, 'Output Schema');
    } catch (e: any) {
      setFormError(e.message);
      return;
    }

    const payload = {
      func_key: fk,
      display_name: displayName,
      description: description || '',
      method: method.toUpperCase(),
      tags: tags,
      input_schema: inputSchema,
      output_schema: outputSchema,
      additional_prompt: additionalPrompt || '',
    };

    if (funcDialogMode === 'create') {
      axios
        .post(`${API_BASE}mcp-functions/${mk}`, payload, { headers: authHeaders })
        .then((res) => {
          if (res.data.success) {
            closeFuncDialog();
            fetchFunctions();
          } else {
            setFormError(res.data.message || '함수 생성 실패');
          }
        })
        .catch(() => setFormError('함수 생성 중 오류가 발생했습니다.'));
    } else {
      const targetKey = editingFuncKey!;
      axios
        .put(`${API_BASE}mcp-functions/${mk}/${encodeURIComponent(targetKey)}`, payload, {
          headers: authHeaders,
        })
        .then((res) => {
          if (res.data.success) {
            closeFuncDialog();
            fetchFunctions();
          } else {
            setFormError(res.data.message || '함수 수정 실패');
          }
        })
        .catch(() => setFormError('함수 수정 중 오류가 발생했습니다.'));
    }
  };

  const handleDeleteModule = () => {
    if (!module_key) return;
    if (!window.confirm('정말 이 모듈을 전체 삭제하시겠습니까? (함수 포함)')) return;
    axios
      .delete(`${API_BASE}mcp-modules/${module_key}`, { headers: authHeaders })
      .then((res) => {
        if (res.data.success) {
          navigate(-1);
        } else {
          setError(res.data.message || '삭제 실패');
        }
      })
      .catch(() => setError('삭제 중 오류 발생'));
  };

  if (error) return (
    <Box sx={{ p: 4, textAlign: "center" }}>
      <Typography variant="h6" color="error" gutterBottom>오류 발생</Typography>
      <Typography color="text.secondary">{error}</Typography>
      <Button variant="outlined" sx={{ mt: 2 }} onClick={() => navigate(-1)}>뒤로 가기</Button>
    </Box>
  );

  if (moduleLoading || !module) {
    return (
      <Box sx={{ p: 2 }}>
        <LoadingBanner text="모듈 정보를 불러오는 중..." />
      </Box>
    );
  }

  const AccessStatusChip = () => {
    if (accessLoading) {
      return (
        <Chip
          size="small"
          icon={<HourglassEmptyIcon fontSize="small" />}
          label="확인 중..."
          variant="outlined"
          sx={{ borderColor: '#666', color: '#aaa' }}
        />
      );
    }
    if (accessStatus === 'approved') {
      return (
        <Chip
          size="small"
          color="success"
          icon={<LockOpenIcon fontSize="small" />}
          label="승인됨"
          variant="filled"
        />
      );
    }
    if (accessStatus === 'requested') {
      return (
        <Chip
          size="small"
          color="warning"
          icon={<HourglassEmptyIcon fontSize="small" />}
          label="승인 대기"
          variant="filled"
        />
      );
    }
    return (
      <Chip
        size="small"
        variant="outlined"
        color="default"
        icon={<SecurityIcon fontSize="small" />}
        label="권한 없음"
        sx={{ borderColor: '#666', color: '#aaa' }}
      />
    );
  };

  const AccessActionButton = () => {
    if (accessLoading) {
      return <Button size="small" variant="outlined" disabled>확인 중...</Button>;
    }
    if (accessStatus === 'approved') {
      return (
        <Button
          size="small"
          variant="outlined"
          color="error"
          onClick={leaveAccess}
          disabled={accessBusy}
        >
          {accessBusy ? '처리 중...' : '접근 해지'}
        </Button>
      );
    }
    if (accessStatus === 'requested') {
      return (
        <Button
          size="small"
          variant="outlined"
          color="inherit"
          onClick={cancelRequest}
          disabled={accessBusy}
          sx={{ borderColor: '#666', color: '#ccc' }}
        >
          {accessBusy ? '처리 중...' : '요청 취소'}
        </Button>
      );
    }
    return (
      <Button
        size="small"
        variant="contained"
        onClick={requestAccess}
        disabled={accessBusy}
      >
        {accessBusy ? '요청 중...' : '접근 요청'}
      </Button>
    );
  };

  return (
    <Box sx={{ p: 3 }}>
      {(moduleLoading || functionsLoading) && (
        <LoadingBanner text="데이터를 불러오는 중..." />
      )}

      {/* 상단 네비게이션 및 타이틀 */}
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Stack direction="row" spacing={2} alignItems="center">
          <IconButton onClick={() => navigate(-1)} sx={{ color: "#fff" }}>
            <ArrowBackIcon />
          </IconButton>
          <Box>
            <Typography variant="h5" fontWeight="bold" color="#fff">
              {module.module_key}
            </Typography>
            <Typography variant="body2" color="grey.500">
              {module.endpoint_prefix}
            </Typography>
          </Box>
        </Stack>
        
        <Stack direction="row" spacing={1}>
          {isOwnerOrAdmin && (
            <>
              <Button variant="outlined" color="primary" onClick={() => navigate(`/mcp/${module_key}/edit`)}>
                전체 편집
              </Button>
              <Button variant="outlined" color="error" onClick={handleDeleteModule}>
                전체 삭제
              </Button>
            </>
          )}
        </Stack>
      </Box>

      {/* 모듈 상세 정보 카드 */}
      <Paper variant="outlined" sx={{ p: 3, mb: 3, bgcolor: "#1e1e1e", borderRadius: 2 }}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={8}>
            <Typography variant="subtitle1" fontWeight="bold" color="#fff" gutterBottom>
              Description
            </Typography>
            <Typography variant="body1" color="grey.300" paragraph>
              {module.description || "설명이 없습니다."}
            </Typography>

            <Divider sx={{ my: 2, borderColor: "#333" }} />

            <Stack direction="row" spacing={1} alignItems="center">
              <Typography variant="caption" color="grey.500">TAGS:</Typography>
              {normalizeTags(module.tags).length > 0 ? (
                normalizeTags(module.tags).map((t, i) => (
                  <Chip key={i} size="small" label={t} sx={{ bgcolor: "rgba(255,255,255,0.1)", color: "#ddd" }} />
                ))
              ) : (
                <Typography variant="caption" color="grey.600">없음</Typography>
              )}
            </Stack>
          </Grid>

          <Grid item xs={12} md={4}>
            <Paper elevation={0} sx={{ p: 2, bgcolor: "rgba(0,0,0,0.3)", borderRadius: 2 }}>
              <Stack spacing={2}>
                <Box display="flex" justifyContent="space-between">
                  <Typography variant="body2" color="grey.400">Owner</Typography>
                  <Typography variant="body2" color="#fff" fontWeight="bold">{module.owner_user_id || "—"}</Typography>
                </Box>
                <Box display="flex" justifyContent="space-between">
                  <Typography variant="body2" color="grey.400">Auto Approve</Typography>
                  <Chip
                    size="small"
                    label={module.auto_approve ? 'ON' : 'OFF'}
                    color={module.auto_approve ? 'success' : 'default'}
                    variant="outlined"
                    sx={{ height: 20 }}
                  />
                </Box>
                {/* ✅ org_id 표시 추가 (디버깅용으로도 유용) */}
                <Box display="flex" justifyContent="space-between">
                  <Typography variant="body2" color="grey.400">Org ID</Typography>
                  <Typography variant="body2" color="grey.300">{module.org_id || "—"}</Typography>
                </Box>

                <Divider sx={{ borderColor: "#444" }} />
                <Box display="flex" justifyContent="space-between" alignItems="center">
                  <Typography variant="body2" color="grey.400">My Access</Typography>
                  <AccessStatusChip />
                </Box>
                <Box pt={1}>
                  <AccessActionButton />
                </Box>
              </Stack>
            </Paper>
          </Grid>
        </Grid>
      </Paper>

      {/* 함수 목록 섹션 */}
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h6" color="#fff" fontWeight="bold">
          Functions ({functions.length})
        </Typography>
        {isOwnerOrAdmin && (
          <Button variant="contained" startIcon={<AddIcon />} onClick={openCreateFunc}>
            함수 추가
          </Button>
        )}
      </Box>

      {/* 함수 목록 로딩 */}
      {functionsLoading && (
        <Paper variant="outlined" sx={{ p: 3, bgcolor: '#1e1e1e', display: 'flex', gap: 2, alignItems: 'center' }}>
          <CircularProgress size={24} />
          <Typography color="grey.500">함수 목록을 불러오는 중...</Typography>
        </Paper>
      )}

      {/* 함수 목록이 비었을 때 */}
      {!functionsLoading && functions.length === 0 && (
        <Paper variant="outlined" sx={{ p: 6, textAlign: 'center', bgcolor: '#1e1e1e', color: '#666' }}>
          등록된 함수가 없습니다.
        </Paper>
      )}

      {/* 함수 리스트 (Accordion) */}
      {!functionsLoading && functions.map((fn) => (
        <Accordion key={fn.func_key} sx={{ bgcolor: '#252525', color: '#fff', mb: 1, '&:before': { display: 'none' } }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#fff' }} />}>
            <Grid container alignItems="center" spacing={2}>
              <Grid item>
                <Chip
                  label={fn.method}
                  size="small"
                  variant="outlined"
                  color={fn.method === 'GET' ? 'info' : fn.method === 'POST' ? 'success' : 'default'}
                  sx={{ fontWeight: 'bold', minWidth: 60 }}
                />
              </Grid>
              <Grid item xs>
                <Typography fontWeight="bold">{fn.func_key}</Typography>
                <Typography variant="caption" color="grey.400">{fn.display_name}</Typography>
              </Grid>
              {isOwnerOrAdmin && (
                <Grid item>
                  <IconButton size="small" onClick={(e) => { e.stopPropagation(); openEditFunc(fn); }} sx={{ color: '#aaa' }}>
                    <EditIcon fontSize="small" />
                  </IconButton>
                  <IconButton size="small" onClick={(e) => {
                    e.stopPropagation();
                    if (window.confirm(`함수 "${fn.func_key}"를 삭제하시겠습니까?`)) {
                      axios.delete(`${API_BASE}mcp-functions/${module_key}/${encodeURIComponent(fn.func_key)}`, { headers: authHeaders })
                        .then((res) => {
                          if (res.data.success) fetchFunctions();
                          else setError(res.data.message);
                        });
                    }
                  }} sx={{ color: '#f44336' }}>
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </Grid>
              )}
            </Grid>
          </AccordionSummary>
          <AccordionDetails sx={{ bgcolor: '#1e1e1e', borderTop: '1px solid #333' }}>
            <Typography variant="body2" color="grey.300" paragraph>
              {fn.description || "설명이 없습니다."}
            </Typography>
            
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Typography variant="caption" color="grey.500" gutterBottom>INPUT SCHEMA</Typography>
                <Paper variant="outlined" sx={{ bgcolor: 'rgba(0,0,0,0.2)', p: 0, overflow: 'hidden' }}>
                  <Table size="small">
                    <TableHead sx={{ bgcolor: '#333' }}>
                      <TableRow>
                        <TableCell sx={{ color: '#ccc', py: 0.5 }}>Name</TableCell>
                        <TableCell sx={{ color: '#ccc', py: 0.5 }}>Type</TableCell>
                        <TableCell sx={{ color: '#ccc', py: 0.5 }}>Desc</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {Object.keys(fn.input_schema || {}).length === 0 ? (
                        <TableRow><TableCell colSpan={3} sx={{ color: '#666', textAlign: 'center' }}>No Input</TableCell></TableRow>
                      ) : (
                        Object.entries(fn.input_schema || {}).map(([key, meta]) => (
                          <TableRow key={key}>
                            <TableCell sx={{ color: '#fff' }}>{key} {(meta as any).required && '*'}</TableCell>
                            <TableCell sx={{ color: '#aaa' }}>{(meta as any).type}</TableCell>
                            <TableCell sx={{ color: '#aaa' }}>{(meta as any).description}</TableCell>
                          </TableRow>
                        ))
                      )}
                    </TableBody>
                  </Table>
                </Paper>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="caption" color="grey.500" gutterBottom>OUTPUT SCHEMA</Typography>
                <Paper variant="outlined" sx={{ bgcolor: 'rgba(0,0,0,0.2)', p: 0, overflow: 'hidden' }}>
                  <Table size="small">
                    <TableHead sx={{ bgcolor: '#333' }}>
                      <TableRow>
                        <TableCell sx={{ color: '#ccc', py: 0.5 }}>Name</TableCell>
                        <TableCell sx={{ color: '#ccc', py: 0.5 }}>Type</TableCell>
                        <TableCell sx={{ color: '#ccc', py: 0.5 }}>Desc</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {Object.keys(fn.output_schema || {}).length === 0 ? (
                        <TableRow><TableCell colSpan={3} sx={{ color: '#666', textAlign: 'center' }}>No Output</TableCell></TableRow>
                      ) : (
                        Object.entries(fn.output_schema || {}).map(([key, meta]) => (
                          <TableRow key={key}>
                            <TableCell sx={{ color: '#fff' }}>{key}</TableCell>
                            <TableCell sx={{ color: '#aaa' }}>{(meta as any).type}</TableCell>
                            <TableCell sx={{ color: '#aaa' }}>{(meta as any).description}</TableCell>
                          </TableRow>
                        ))
                      )}
                    </TableBody>
                  </Table>
                </Paper>
              </Grid>
            </Grid>

            {fn.additional_prompt && (
              <Box mt={2}>
                <Typography variant="caption" color="grey.500">ADDITIONAL PROMPT</Typography>
                <Paper variant="outlined" sx={{ p: 1.5, bgcolor: '#111', color: '#ccc', fontSize: '0.85rem', fontFamily: 'monospace' }}>
                  {fn.additional_prompt}
                </Paper>
              </Box>
            )}
          </AccordionDetails>
        </Accordion>
      ))}

      {/* 함수 추가/편집 다이얼로그 */}
      <Dialog 
        open={funcDialogOpen} 
        onClose={closeFuncDialog} 
        maxWidth="md" 
        fullWidth
        PaperProps={{ sx: { bgcolor: "#1e1e1e", color: "#fff" } }}
      >
        <DialogTitle sx={{ borderBottom: "1px solid #333" }}>
          {funcDialogMode === 'create' ? '함수 추가' : `함수 편집 (${editingFuncKey})`}
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          {formError && (
            <Alert severity="error" sx={{ mb: 2 }}>{formError}</Alert>
          )}

          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField
                label="Function Key (ID)"
                value={funcKey}
                onChange={(e) => setFuncKey(e.target.value)}
                fullWidth
                disabled={funcDialogMode === 'edit'}
                helperText="영문, 숫자, 언더스코어(_)만 사용 가능"
                InputLabelProps={{ style: { color: "#aaa" } }}
                InputProps={{ style: { color: "#fff" }, sx: { ".MuiOutlinedInput-notchedOutline": { borderColor: "#555" } } }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="Display Name"
                value={displayName}
                onChange={(e) => setDisplayName(e.target.value)}
                fullWidth
                InputLabelProps={{ style: { color: "#aaa" } }}
                InputProps={{ style: { color: "#fff" }, sx: { ".MuiOutlinedInput-notchedOutline": { borderColor: "#555" } } }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="Method"
                value={method}
                onChange={(e) => setMethod(e.target.value)}
                fullWidth
                helperText="예: POST, GET"
                InputLabelProps={{ style: { color: "#aaa" } }}
                InputProps={{ style: { color: "#fff" }, sx: { ".MuiOutlinedInput-notchedOutline": { borderColor: "#555" } } }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="Description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                fullWidth
                InputLabelProps={{ style: { color: "#aaa" } }}
                InputProps={{ style: { color: "#fff" }, sx: { ".MuiOutlinedInput-notchedOutline": { borderColor: "#555" } } }}
              />
            </Grid>

            {/* 태그 입력 */}
            <Grid item xs={12}>
              <Typography variant="caption" color="grey.500" sx={{ mb: 1, display: "block" }}>
                Tags (Enter로 추가)
              </Typography>
              <TextField
                size="small"
                value={tagInput}
                onChange={(e) => setTagInput(e.target.value)}
                onKeyDown={handleTagKeyDown}
                onBlur={handleTagBlur}
                fullWidth
                error={!!tagError}
                helperText={tagError}
                InputProps={{ style: { color: "#fff" }, sx: { ".MuiOutlinedInput-notchedOutline": { borderColor: "#555" } } }}
              />
              <Stack direction="row" spacing={1} flexWrap="wrap" sx={{ mt: 1 }}>
                {tags.map((t, i) => (
                  <Chip key={i} label={t} onDelete={() => removeTag(i)} size="small" sx={{ bgcolor: "#333", color: "#fff" }} />
                ))}
              </Stack>
            </Grid>

            {/* JSON Schema Inputs */}
            <Grid item xs={12} md={6}>
              <TextField
                label="Input Schema (JSON)"
                value={inputSchemaText}
                onChange={(e) => setInputSchemaText(e.target.value)}
                fullWidth
                multiline
                minRows={6}
                InputLabelProps={{ style: { color: "#aaa" } }}
                InputProps={{ 
                  style: { color: "#fff", fontFamily: "monospace", fontSize: "0.85rem" }, 
                  sx: { ".MuiOutlinedInput-notchedOutline": { borderColor: "#555" } } 
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="Output Schema (JSON)"
                value={outputSchemaText}
                onChange={(e) => setOutputSchemaText(e.target.value)}
                fullWidth
                multiline
                minRows={6}
                InputLabelProps={{ style: { color: "#aaa" } }}
                InputProps={{ 
                  style: { color: "#fff", fontFamily: "monospace", fontSize: "0.85rem" }, 
                  sx: { ".MuiOutlinedInput-notchedOutline": { borderColor: "#555" } } 
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="Additional Prompt"
                value={additionalPrompt}
                onChange={(e) => setAdditionalPrompt(e.target.value)}
                fullWidth
                multiline
                minRows={3}
                placeholder="LLM에게 전달할 추가 지침을 입력하세요."
                InputLabelProps={{ style: { color: "#aaa" } }}
                InputProps={{ style: { color: "#fff" }, sx: { ".MuiOutlinedInput-notchedOutline": { borderColor: "#555" } } }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ p: 2, borderTop: "1px solid #333" }}>
          <Button onClick={closeFuncDialog} sx={{ color: "#aaa" }}>취소</Button>
          <Button variant="contained" onClick={submitFunc}>저장</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}